import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { NavBar } from 'components/NavBar/NavBar'
import { StepNumber } from 'pages/Accomodation/Accommodation.style'
import { BodyText } from 'styling/Typography'
import { NextIcon } from 'pages/Accomodation/icons/NextIcon'
import { useEffect, useState } from 'react'
import { Identity } from './Sections/Identity'
import { Scope } from './Sections/Scope'
import { Targets } from './Sections/Targets'
import { Phases } from './Sections/Phases'
import { Review } from './Sections/Review'
import { IOperationPlanState } from 'types/operationPlans.interface'
import { Horizon } from './Sections/Horizon'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { useNavigate, useParams } from 'react-router-dom'
import { clearSingleOperationPlan, editOperationPlan, getSingleOperationPlan } from 'features/operations/plansSlice'

export const EditPlan = () => {
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const { id } = useParams()
    const [state, setState] = useState<IOperationPlanState>({
        name: null,
        code: null,
        site: null,
        owner: null,
        zoneScopeLevel: null,
        zoneScopeIds: [],
        priority: null,
        objective: null,
        targetUnit: null,
        targetValue: null,
        targetBudgetCost: null,
        targetCurrencyCode: null,
        dueAt: null,
        boardVisibility: null,
        autoPauseOnL3Plus: null,
        phases: [],
        horizon: {
            horizonType: null,
            schedulerRunFreqMin: null,
            replenishThreshold: null,
            maxQueueSize: null,
        },
    })
    const [step, setStep] = useState(1)
    const { singlePlan } = useSelector((state: RootState) => state.operationPlans)

    useEffect(() => {
        dispatch(getSingleOperationPlan(id))
        return () => {
            dispatch(clearSingleOperationPlan())
        }
    }, [id])

    useEffect(() => {
        if (singlePlan) {
            setState(singlePlan)
        }
    }, [singlePlan])

    const handleSave = async () => {
        const resp = await dispatch(editOperationPlan({ id, state }))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(`/operations/plans/${resp.payload.id}`, { replace: true })
        }
    }

    const renderStep = () => {
        switch (step) {
            case 1:
                return <Identity state={state} setStep={setStep} setState={setState} />
            case 2:
                return <Scope state={state} setStep={setStep} setState={setState} />
            case 3:
                return <Targets state={state} setStep={setStep} setState={setState} />
            case 4:
                return <Phases state={state} setStep={setStep} setState={setState} />
            case 5:
                return <Horizon state={state} setStep={setStep} setState={setState} />
            case 6:
                return <Review state={state} setStep={setStep} handleSave={handleSave} />
        }
    }

    return <>
        <NavBar />
        <PageWrapper noFooter>
            <H1WithBack arrow title='Edit Plan' />
            <Flex gap='1rem' center style={{ margin: '2rem 0' }} >
                <Step step={1} name='Identity' active={step === 1} onClick={() => setStep(1)} />
                <NextIcon />
                <Step step={2} name='Scope' active={step === 2} onClick={() => setStep(2)} />
                <NextIcon />
                <Step step={3} name='Targets' active={step === 3} onClick={() => setStep(3)} />
                <NextIcon />
                <Step step={4} name='Phases' active={step === 4} onClick={() => setStep(4)} />
                <NextIcon />
                <Step step={5} name='Horizon' active={step === 5} onClick={() => setStep(5)} />
                <NextIcon />
                <Step step={6} name='Review' active={step === 6} onClick={() => setStep(6)} />
            </Flex>
            {renderStep()}
        </PageWrapper>
    </>
}

const Step = ({ step, name, active, onClick }: { step: number, name: string, active: boolean, onClick?: () => void }) => {
    return <Flex center gap='1rem' onClick={onClick} style={{ cursor: 'pointer' }} >
        <StepNumber active={active} >  {step}</StepNumber>
        <BodyText grey={!active} >{name}</BodyText>
    </Flex>
}